import { render, staticRenderFns } from "./Axiostest.vue?vue&type=template&id=c94aad84"
import script from "./Axiostest.vue?vue&type=script&lang=js"
export * from "./Axiostest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c94aad84')) {
      api.createRecord('c94aad84', component.options)
    } else {
      api.reload('c94aad84', component.options)
    }
    module.hot.accept("./Axiostest.vue?vue&type=template&id=c94aad84", function () {
      api.rerender('c94aad84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Axiostest.vue"
export default component.exports